const initialState = {
    activeMenuItem: '',
    activeSubMenuItem: '',
    activeSecondarySidebar: ''
};

export default initialState;
